module.exports = __webpack_public_path__ + "img/25.10468cb9.png";